import { useEffect, useState } from "react";
import { SIDEBAR_MIN, TWO_COLUMN_MIN } from "./layout";

const matches = (query) => typeof window !== "undefined" && !!window.matchMedia?.(query).matches;

// True while the window is at least `px` wide, following it as it's resized.
export function useMinWidth(px) {
  const query = `(min-width: ${px}px)`;
  const [wide, setWide] = useState(() => matches(query));
  useEffect(() => {
    const list = window.matchMedia?.(query);
    if (!list) return undefined;
    const onChange = () => setWide(list.matches);
    onChange();
    list.addEventListener("change", onChange);
    return () => list.removeEventListener("change", onChange);
  }, [query]);
  return wide;
}

// From a tablet held sideways up, where the sidebar replaces the bottom bar and the top bar's shared buttons.
export const useWideScreen = () => useMinWidth(SIDEBAR_MIN);
// Where a page with two parts shows them side by side (the same width as wideCss's `page-columns`).
export const useTwoColumns = () => useMinWidth(TWO_COLUMN_MIN);
